import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useEffect } from 'react';
import { tracker } from '..';

type ReturnValue = {
  loading: boolean;
};

export const useDispensaryMonitor = (): ReturnValue => {
  const { dispensary, loading } = useDispensary();

  useEffect(() => {
    if (!loading && dispensary) {
      tracker.setContext({ activeDispensary: dispensary });
    }
  }, [loading, dispensary]);
  return { loading };
};
